import { inject, reactive, ref, provide, computed} from 'vue';

import Card from '@/components/content/views/card/card.vue';
import FormattingService from '@/services/formatting.service';
import Tooltip from '@/components/content/views/tooltip/tooltip.vue';
import SkeletonLoader from '@/components/content/views/skeleton-loader/skeleton-loader.vue';
import { Api } from '@/services/api.service'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMedal } from '@fortawesome/free-solid-svg-icons'

library.add(faMedal);

export default {
  name: 'Track',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    Card,
    Tooltip,
    SkeletonLoader,
    FontAwesomeIcon
  },
  setup(props) {

    let config = inject('config');
    const { api, debug } = config;

    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');


    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      courses: computed(() => state.item.courses.length),
      lessons: computed(() => {
        let count = 0;
        if(state.item.courses.length) {
          state.item.courses.forEach(course => {
            count += course.lessons.length;
          })
        }
        return count;
      }),
      imageUrl: computed(() => {
        if(!state.item.images) return '';
        if(state.item.images['300w']) return state.item.images['300w'];
        if(state.item.images['500w']) return state.item.images['500w'];
        return state.item.images.full;
      }),
      activeIndex: 0,
      completedCourses: 0,
      isCompleted: computed(() => state.courses === state.completedCourses),
      showTooltip: false,
      percentage: computed(() => state.completedCourses === 0 ? 0 : (state.completedCourses / state.courses * 100) ),
    });

    const initialize = async () => {
      let url = `${api.uri}/${api.version}/users/${state.member.id}/content/${state.item.id}/position?token=${state.member.token}`;
      let response = await Api.get(url, headers);
      if(response.status !== 'error') {
        state.activeIndex = response.data.data.index;
        state.completedCourses = response.data.data.completed;
        if (debug) {
          console.log('Track Initialize(): response ', response)
        }
      }
    }

    initialize();

    return {
      state,
      FormattingService,
    }
  }
}
